module.exports = {"230102001":"兆麟街道","230102002":"新阳路街道","230102003":"抚顺街道","230102004":"共乐街道","230102005":"新华街道","230102006":"城乡路街道","230102007":"工农街道","230102008":"尚志街道","230102009":"斯大林街道","230102010":"通江街道","230102011":"经纬街道","230102012":"工程街道","230102013":"安静街道","230102014":"安和街道","230102015":"正阳河街道","230102016":"建国街道","230102017":"康安街道","230102018":"爱建街道","230102019":"群力街道","230102101":"太平镇","230102102":"新发镇","230102103":"新农镇","230102104":"榆树镇","230102500":"闫家岗农场","230102579":"道里区农垦"}


//////////////////
// WEBPACK FOOTER
// ./src/town/230102.json
// module id = 615
// module chunks = 0